<template>

     <div class="px-6 flex justify-between items-center">
        
        <div class="flex-1 flex justify-center items-center  ">
          <p class="text-2xl font-semibold">Check In</p>
        </div>
      </div>
      <div class="pt-8 flex justify-center items-center flex-col">
        <div class="rounded-full overflow-hidden bg-g300">
          <img src="../../public/asset/avatar.jpg" alt="" class="w-[140px] h-[140px] object-cover">
        </div>

      

        

      </div>
      <div  v-if="dataload" class="pt-8 p-6">

       

        <div class="border border-n40 dark:border-darkN40 flex flex-col gap-5 p-4   rounded-2xl" style="background-color: #fff;">
          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Tanggal</p>
            <p class="text-sm font-medium text-g300">{{items.data.tanggal }} </p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Jam Checkin</p>
            <p class="text-sm">{{items.data.jam_chekin }}</p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Jam Checkin</p>
            <p class="text-sm">{{items.data.jam_checkout }}</p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Keterangan</p>
            <p class="text-sm">{{items.data.keterangan }}</p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Status</p>
            <p class="text-sm">{{items.data.sts }}</p>
          </div>

          <div class="flex justify-between items-center pb-5   ">         
           
            <router-link  to="/" class="text-sm px-4 py-2 rounded-md bg-o300 text-white">
              Kembali
            </router-link>
          </div>
        
 
        </div>

 
      </div>
      <div  v-else class="pt-8 p-6">
         <pulse-loader :loading="true" :color="color" :size="size" style="position: absolute; top: 50%;right: 45%;"></pulse-loader>
        <div class="border border-n40 dark:border-darkN40 flex flex-col gap-5 p-4   rounded-2xl" style="background-color: #fff;">
          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Tanggal</p>
            <p class="text-sm font-medium text-g300">  </p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Jam Checkin</p>
            <p class="text-sm"></p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Jam Checkin</p>
            <p class="text-sm"></p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Keterangan</p>
            <p class="text-sm"></p>
          </div>

          <div class="flex justify-between items-center pb-5 border-b border-dashed border-n40 dark:border-darkN40">
            <p class="text-sm text-n500 dark:text-darkN500">Status</p>
            <p class="text-sm"></p>
          </div>

          <div class="flex justify-between items-center pb-5   ">         
           
            <router-link  to="/" class="text-sm px-4 py-2 rounded-md bg-o300 text-white">
              Kembali
            </router-link>
          </div>
        
 
        </div>

 
      </div>
      

</template>

<script setup>

import { onMounted,ref} from 'vue'
import { useRoute } from 'vue-router'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'



const route = useRoute()
const items = ref([])
const dataload = ref(false)

console.log(route.params.id)

onMounted(async () => { 

  const token = localStorage.getItem("token");

  const res = await fetch("https://kiyanrahayu.my.id/api2/detail?id=" +route.params.id ,{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })

 if(res.ok){

      const dt = await res.json()    
      items.value = dt  

      dataload.value = true

      console.log(items.value.data.tanggal)
 }


})

</script>

    <style>
      .skeleton {
        background-color: #eee;
        background-image: linear-gradient(90deg, #eee, #f5f5f5, #eee);
        background-size: 200px 100%;
        background-repeat: no-repeat;
        border-radius: 4px;
        display: inline-block;
        line-height: 1;
        width: 100%;
        height: 50px;
        margin: 14px 0px 14px;
        animation: skeleton-animation 1.5s ease-in-out infinite;
      }

      @keyframes skeleton-animation {
        0% {
          background-position: -200px 0;
        }
        100% {
          background-position: calc(200px + 100%) 0;
        }
      }
    </style>